import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { TitleCard } from '../QualityPage/MetricsSection/MetricsHelpfullComponents';
import apiService from '../../services/apiService';

//  <DeployFlag deployFlag={deploymentData.deployed} />
// Card that has information about the deployment of the project
export const DeployCard = ({ deploymentData, tooltipMessage, title, projectId, onBack }) => {
  const [selectedConfig, setSelectedConfig] = useState({ ...deploymentData });
  const [deploymentStatus, setDeploymentStatus] = useState('loading');

  useEffect(() => {
    setSelectedConfig(deploymentData);
  }, [deploymentData]);

  // Show the deployment card when the deployment is done
  if (deploymentStatus === 'settled') {
    return (
      <div style={{ width: '50%', margin: '0.1rem' }}>
        <TitleCard title={title} tooltipMessage={tooltipMessage} />
        <div
          style={{
            padding: '1rem',
            border: 'solid',
            borderBottomLeftRadius: '0.5rem',
            borderBottomRightRadius: '0.5rem',
            borderColor: '#0c4d82',
            height: 'auto',
            display: 'grid',
            gridTemplateRows: '1fr 2fr 1fr',
          }}
        >
          <section>
            <h2>Deploy to your server</h2>
            <p>
              Your project has been successfully uploaded to github. You can now deploy it to your
              server by clicking the deploy button.
            </p>
          </section>
          <section
            style={{
              display: 'grid',
              gridTemplateRows: '1fr 1fr 1fr',
            }}
          >
            {' '}
            {selectedConfig && <DeployFlag selectedConfig={selectedConfig} />}
            {selectedConfig && <ServerSelection selectedConfig={selectedConfig} />}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
              <span style={{ color: '#0c4d82' }}>Project Url: </span>
              {selectedConfig?.url && <span>&nbsp;{selectedConfig.url}</span>}
            </div>
          </section>
          <section
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '40%',
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            <CancelButton onBack={onBack} />
            <DeployButton projectIdToDeploy={projectId} setDeploymentStatus={setDeploymentStatus} />
          </section>
        </div>
      </div>
    );
  } // Show the spinner while the deployment is in progress
  if (deploymentStatus === 'loading')
    return (
      <div style={{ width: '50%', margin: '0.1rem' }}>
        <TitleCard title={title} tooltipMessage={tooltipMessage} />
        <div
          style={{
            padding: '1rem',
            border: 'solid',
            borderBottomLeftRadius: '0.5rem',
            borderBottomRightRadius: '0.5rem',
            borderColor: '#0c4d82',
            height: '75%',
            display: 'grid',
            gridTemplateRows: '2fr 1fr',
          }}
        >
          <Spinner projectIdToDeploy={projectId} setDeploymentStatus={setDeploymentStatus} />{' '}
        </div>
      </div>
    );

    return null;
};

// Flag with information about the status of the server online/offline
export const DeployFlag = ({ selectedConfig }) => {
  const [deployFlag, setDeployFlag] = useState(false);
  useEffect(() => {
    if (!selectedConfig.serverIpAddress) return;
    if (selectedConfig.serverName === 'local') setDeployFlag(false);
    else {
      apiService
        .doAction({
          url: `${selectedConfig.url}/hello`,
          method: 'GET',
        })
        .then((res) => {
          setDeployFlag(res.status === 200);
        })
        .catch(() => setDeployFlag(false));
    }
  }, [selectedConfig]);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Server Status: </span>
      <div>
        <span
          style={{
            height: '1rem',
            width: '1rem',
            backgroundColor: deployFlag ? 'green' : 'red',
            borderRadius: '50%',
            display: 'inline-block',
          }}
        />
        <span>&nbsp; {deployFlag ? 'Online' : 'Offline'}</span>
      </div>
    </div>
  );
};
// Show selected server
const ServerSelection = ({ selectedConfig }) => 
  (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Deploy server: </span>
      {/* {selectedConfig?._id && (
        <select
          value={selectedConfig._id}
          onChange={handleSelection}
          style={{ borderWidth: '0', width: '40%', minWidth: 'fit-content' }}
        >
          {optionsArray}
        </select>
      )} */}
      {selectedConfig && <span>&nbsp;{selectedConfig.name}</span>}
    </div>
  );
// Button that handles the deployment of the project
const DeployButton = ({ projectIdToDeploy, setDeploymentStatus }) => {
  function clickDeploy(projectId) {
    apiService
      .deployAProject(projectId)
      .then(() => setDeploymentStatus('loading'))
      .catch((error) => {
        throw error;
      });
  }
  return (
    <button
      type="button"
      className={clsx('cleanCssButton', 'teamselector')}
      onClick={() => clickDeploy(projectIdToDeploy)}
      style={{
        color: 'white',
        backgroundColor: '#0c4d82',
        border: '0.2rem solid #0c4d82',
        borderRadius: '0.5rem',
        width: '75%',
      }}
    >
      Deploy
    </button>
  );
};

function checkActionsStatus(actions) {
  if (actions.filter((action) => action.status !== 'completed').length) return false;
  return true;
}

function checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus) {
  apiService
    .listProjectActions(projectIdToDeploy)
    .then((answer) => {
      if (checkActionsStatus(answer.data.actions)) setDeploymentStatus('settled');
      else setDeploymentStatus('loading');
    })
    .catch((error) => {
      setDeploymentStatus('settled');
      throw error;
    });
}

const Spinner = ({ projectIdToDeploy, setDeploymentStatus }) => {
  useEffect(() => {
    let timerId;
    if (projectIdToDeploy)
      timerId = setInterval(
        () => checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus),
        10000
      );
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [projectIdToDeploy]);
  return <div id="cover-spin3" />;
};
// Cancellation button that takes you back to the previous step
const CancelButton = ({ onBack }) => (
  <button
    type="button"
    className={clsx('cleanCssButton', 'teamselector')}
    onClick={() => {
      onBack();
    }}
    style={{
      color: '#0c4d82',
      border: '0.2rem solid #0c4d82',
      borderRadius: '0.5rem',
      width: '75%',
    }}
  >
    Back
  </button>
);
